import { StaticImage } from "gatsby-plugin-image"
import React from "react"

import Button from "../Button"

const Grid = () => {
  return (
    <section className="flex flex-col items-center pb-[61px]">
      <div className="grid gap-[20px] mb-11 md:grid-cols-[32.35%_2fr_15.4%] md:grid-rows-[repeat(3,31.2%)]">
        <StaticImage
          className="md:row-[1/3]"
          src="../../images/grid-first.webp"
          quality={95}
          formats={["auto", "webp", "avif"]}
          alt="hero image"
        />
        <StaticImage
          className="md:col-[1/2] md:row-[3/4]"
          src="../../images/grid-second.webp"
          quality={95}
          formats={["auto", "webp", "avif"]}
          alt="hero image"
        />
        <StaticImage
          className="md:col-[2/3] md:row-[1/4]"
          src="../../images/grid-third.webp"
          quality={95}
          formats={["auto", "webp", "avif"]}
          alt="hero image"
        />
        <StaticImage
          src="../../images/grid-fourth.webp"
          quality={95}
          formats={["auto", "webp", "avif"]}
          alt="hero image"
        />
        <StaticImage
          src="../../images/grid-fifth.webp"
          quality={95}
          formats={["auto", "webp", "avif"]}
          alt="hero image"
        />
        <StaticImage
          className="md:col-[3/4] md:row-[3/4]"
          src="../../images/grid-sixth.webp"
          quality={95}
          formats={["auto", "webp", "avif"]}
          alt="hero image"
        />
      </div>

      <Button size="xs" color="transparent">
        Load more
      </Button>
    </section>
  )
}

export default Grid
